/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { getDate as f, cloneDate as v } from "@progress/kendo-date-math";
import { EMPTY_SELECTIONRANGE as F } from "./calendar/models/SelectionRange.mjs";
function W(t) {
  const n = (r, o, s, ...u) => o[s] === null ? null : (r ? t.isRequired : t)(o, s, ...u), e = n.bind(null, !1);
  return e.isRequired = n.bind(null, !0), e;
}
const d = (t, n, e) => n === void 0 || e === void 0 || n <= t && t <= e ? t : t < n ? n : e, k = new Date(1980, 0, 1), H = new Date(1900, 0, 1), L = new Date(2099, 11, 31), q = new Date(1980, 0, 1), G = new Date(1980, 0, 1, 23, 59, 59), O = (t, n) => {
  const e = v(t);
  return e.setHours(n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()), e;
}, X = () => f(/* @__PURE__ */ new Date()), j = (t, n, e) => !t || !(n && n > t || e && e < t), P = (t, n, e) => t === null || !(n && f(n) > f(t) || e && f(e) < f(t)), Y = (t, n) => {
  const { start: e, end: r } = n || F;
  return !e || !r ? !1 : e < t && t < r;
}, z = (t, n, e = 1) => {
  const r = [];
  for (let o = t; o < n; o = o + e)
    r.push(o);
  return r;
}, B = (t, n, e) => n.getTime() <= t.getTime() && t.getTime() <= e.getTime(), J = (t, n) => t.slice(n).concat(t.slice(0, n)), K = (t, n, e) => t && (n && t < n ? v(n) : e && t > e ? v(e) : t), Q = (t) => (n, e = "", r = {}) => {
  const o = document.createElement(t);
  return o.className = e, Object.keys(r).forEach((s) => {
    o.style[s] = r[s];
  }), typeof n == "string" ? o.innerHTML = n || "" : (n || []).forEach((s) => s && o.appendChild(s)), o;
};
function U(t, n, e = {}) {
  let r, o;
  e.maxWait;
  let s, u, l;
  const g = window, M = !1, h = !1, D = !n && n !== 0 && typeof g.requestAnimationFrame == "function";
  if (typeof t != "function")
    throw new TypeError("Expected a function");
  n = +n || 0;
  function I(i) {
    const c = r, m = o;
    return r = o = void 0, s = t.apply(m, c), s;
  }
  function T(i, c) {
    return D ? (g.cancelAnimationFrame(u), g.requestAnimationFrame(i)) : setTimeout(i, c);
  }
  function R(i) {
    if (D)
      return g.cancelAnimationFrame(i);
    clearTimeout(i);
  }
  function b(i) {
    return u = T(E, n), M ? I() : s;
  }
  function N(i) {
    const c = i - l;
    return n - c;
  }
  function p(i) {
    const c = i - l;
    return l === void 0 || c >= n || c < 0 || h;
  }
  function E() {
    const i = Date.now();
    if (p(i))
      return A();
    u = T(E, N(i));
  }
  function A(i) {
    return u = void 0, r ? I() : (r = o = void 0, s);
  }
  function w() {
    u !== void 0 && R(u), r = l = o = u = void 0;
  }
  function y() {
    return u === void 0 ? s : A();
  }
  function C() {
    return u !== void 0;
  }
  function a(...i) {
    const c = Date.now(), m = p(c);
    return r = i, o = this, l = c, m && u === void 0 ? b() : (u === void 0 && (u = T(E, n)), s);
  }
  return a.cancel = w, a.flush = y, a.pending = C, a;
}
export {
  L as MAX_DATE,
  G as MAX_TIME,
  k as MIDNIGHT_DATE,
  H as MIN_DATE,
  q as MIN_TIME,
  K as dateInRange,
  U as debounce,
  Q as domContainerFactory,
  X as getToday,
  B as intersects,
  P as isInDateRange,
  j as isInRange,
  Y as isInSelectionRange,
  W as nullable,
  z as range,
  O as setTime,
  J as shiftWeekNames,
  d as viewInRange
};
